import { sva } from "styled-system/css";

export const noteCardRecipe = sva({
  slots: ["root", "createdBy", "dateDisplay", "archivedDisplay"],
  base: {
    root: {
      borderRadius: "150",
      flexDir: "column",
      gap: "250",
      p: "300",
    },
    createdBy: {},
    dateDisplay: {},
    archivedDisplay: {
      display: "none",
    },
  },
  variants: {
    visual: {
      editing: {
        root: {
          bgColor: "ink.100",
          border: "2px solid",
          borderColor: "border.dark",
          p: "22px",
        },
      },
      viewing: {
        root: {
          bgColor: "bg.highlight.lightest",
        },
        createdBy: {
          color: "text.highlight.mid",
        },
        dateDisplay: {
          color: "text.highlight.mid",
        },
      },
      archived: {
        root: {
          bgColor: "bg.lightest",
        },
        createdBy: {
          opacity: 0.6,
          color: "text.light",
        },
        dateDisplay: {
          opacity: 0.6,
          color: "text.light",
        },
        archivedDisplay: {
          display: "flex",
          gap: "100",
          alignItems: "center",
          color: "text.light",
        },
      },
    },
  },
  defaultVariants: {
    visual: "viewing",
  },
});
